import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import { Input, SearchSelect } from '../../../../../input'
import { CustomDatePicker } from '../../../../../datepicker'
import { FONTS } from '../../../../../../constants'
import { getExcludeVat, getIncludeVat, getVat } from '../../../../../../function/billing'
import { toNumber } from '../../../../../../function/math'
import { vat } from '../../constants'

export const BillingDetail = ({
  detailState,
  projectRevenue,
  projectAvailable,
}) => {
  const _vat = vat.find(v => v.value === detailState.vat)
  const excludeVat = getExcludeVat(detailState)
  const vatPrice = getVat(detailState)
  const includeVat = getIncludeVat(detailState)

  return (
    <React.Fragment>
      <FlexRow>
        <FlexCol flex={ 1 }>
          <Title>Milestone</Title>
          <AlignCenterWrapper>{ detailState.billing_id }</AlignCenterWrapper>
        </FlexCol>
        <FlexCol flex={ 3 } margin='0 12px'>
          <Title>Process Description</Title>
          <Input
            disabled
            placeholder='Enter Process Description'
            value={ detailState.name || '' }
          />
        </FlexCol>
        <FlexCol flex={ 1 }>
          <Title>Plan Invoice Date</Title>
          <CustomDatePicker
            disabled
            value={ detailState.invoice_date ? moment(detailState.invoice_date).format('DD/MM/YYYY') : null }
          />
        </FlexCol>
      </FlexRow>
      <FlexRow>
        <PriceWrapper>
          <FlexEndCol flex={ 1 }>
            <Title>Project Revenue</Title>
            <Number>฿ ​{projectRevenue}</Number>
          </FlexEndCol>
          <FlexEndCol flex={ 1 }>
            <Title>Available</Title>
            <AvailableNumber value={ toNumber(projectAvailable) }>
              ฿​ {projectAvailable}
            </AvailableNumber>
          </FlexEndCol>
        </PriceWrapper>
        <VatWrapper>
          <FlexEndCol flex={ 2 }>
            <Title>Exc. Vat</Title>
            <Number>฿​ {excludeVat}</Number>
          </FlexEndCol>
          <FlexEndCol flex={ 3 }>
            <Title>VAT</Title>
            <VatRow>
              <Number>฿ ​{vatPrice}</Number>
              <VatDropdown>
                <SearchSelect
                  isDisabled
                  placeholder='Select Vat'
                  options={ vat }
                  value={ _vat }
                />
              </VatDropdown>
            </VatRow>
          </FlexEndCol>
          <FlexEndCol flex={ 2 }>
            <Title>Inc. VAT</Title>
            <Number>฿ {includeVat}</Number>
          </FlexEndCol>
        </VatWrapper>
      </FlexRow>
    </React.Fragment>
  )
}

const Row = styled.div`
  display: flex;
`

const FlexRow = styled(Row)`
  margin-bottom: 16px;
  ${p => p.flex && `flex: ${p.flex}`}
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
`

const FlexCol = styled(Col)`
  margin: ${p => p.margin};
  ${p => p.flex && `flex: ${p.flex}`}
`

const PriceWrapper = styled(Row)`
  align-items: center;
  flex: 2;
  padding: 10px 16px;
  background: #F9F9F9;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
`

const VatWrapper = styled(PriceWrapper)`
  flex: 4;
  margin-left: 12px;
`

const FlexEndCol = styled(FlexCol)`
  align-items: flex-end;
`

const Title = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #333333;
`

const VatRow = styled.div`
  display: flex;
  align-items: center;
`

const VatDropdown = styled.div`
  width: 70px;
  margin-left: 8px;
`

const Number = styled.span`
  font-family: Notosans;
  font-weight: 600;
  font-size: ${FONTS.NORMAL_SIZE};
  color: #1A1A17;
`

const AvailableNumber = styled(Number)`
  color: ${p => {
    if (p.value > 0) return '#27AE60'
    else if (p.value < 0) return '#D44B49'
    return '#1A1A17'
  }};
`

const AlignCenterWrapper = styled(Row)`
  height: 100%;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-billing/view-billing/billing-detail/index.js